import { initializeApp } from 'firebase/app';
import { getAuth, setPersistence, browserSessionPersistence } from 'firebase/auth';

const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);

// Tab-scoped session: closing the tab/browser clears the Firebase session
// instead of persisting it indefinitely in IndexedDB (the SDK default).
setPersistence(auth, browserSessionPersistence).catch((error) => {
  console.error('Failed to set Firebase auth persistence:', error);
});
